import React from "react";
import { Link, NavLink } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ClientNav = () => {
  const { auth } = useAuth();

  const toggleSubMenu = (e) =>
    e.target.parentNode
      .querySelector(".mininav-content")
      .classList.toggle("collapse");
  return (
    <>
      <div className="mainnav__categoriy py-3">
        <h6 className="mainnav__caption mt-0 px-3 fw-bold">Navigation</h6>
        <ul className="mainnav__menu nav flex-column">
          {/* <!-- Link with submenu --> */}
          <li className="nav-item">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "nav-link active" : " nav-link"
              }
            >
              <i className="demo-pli-home fs-5 me-2"></i>
              <span className="nav-label ms-1">Dashboard</span>
            </NavLink>
          </li>
        </ul>
      </div>
      {/* <!-- END : Navigation Category --> */}

      <div className="mainnav__categoriy py-3">
        <h6 className="mainnav__caption mt-0 px-3 fw-bold">App</h6>
        <ul className="mainnav__menu nav flex-column">
          <li className="nav-item">
            <NavLink
              to="/client-account/policies"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
              // onClick={toggleSubMenu}
            >
              <i className="demo-pli-pen-5 fs-5 me-2"></i>
              <span className="nav-label ms-1">Policies</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/client-account/claims"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
              // onClick={toggleSubMenu}
            >
              <i className="demo-psi-coin fs-5 me-2"></i>
              <span className="nav-label ms-1">Claims</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="mainnav__categoriy py-3">
        {/* <h6 className="mainnav__caption mt-0 px-3 fw-bold">Settings</h6> */}
        <ul className="mainnav__menu nav flex-column">
          {/* <li className="nav-item">
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
            >
              <i className="demo-pli-speech-bubble-5 fs-5 me-2"></i>
              <span className="nav-label ms-1">Contact us</span>
            </NavLink>
          </li> */}
          <li className="nav-item has-sub">
            {/* <a href="#" className="mininav-toggle nav-link collapsed">
                    <i className="demo-pli-speech-bubble-5 fs-5 me-2"></i>
                    <span className="nav-label ms-1">Blog Apps</span>
                  </a> */}

            {/* <!-- Blog Apps submenu list --> */}
            {/* <ul className="mininav-content nav collapse">
                    <li className="nav-item">
                      <a href="./blog-apps-blog.html" className="nav-link">
                        Blog
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./blog-apps-blog-list.html" className="nav-link">
                        Blog List
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./blog-apps-blog-list-2.html" className="nav-link">
                        Blog List 2
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./blog-apps-blog-article.html"
                        className="nav-link"
                      >
                        Blog Article
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./blog-apps-manage-posts.html"
                        className="nav-link"
                      >
                        Manage Posts
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./blog-apps-add-edit-posts.html"
                        className="nav-link"
                      >
                        Add Edit Posts
                      </a>
                    </li>
                  </ul> */}
            {/* <!-- END : Blog Apps submenu list --> */}
          </li>
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          {/* <li className="nav-item has-sub">
                  <a href="#" className="mininav-toggle nav-link collapsed">
                    <i className="demo-pli-mail fs-5 me-2"></i>
                    <span className="nav-label ms-1">Email</span>
                  </a> */}

          {/* <!-- Email submenu list --> */}
          {/* <ul className="mininav-content nav collapse">
                    <li className="nav-item">
                      <a href="./email-inbox.html" className="nav-link">
                        Inbox
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./email-view-message.html" className="nav-link">
                        View Message
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./email-compose-message.html" className="nav-link">
                        Compose Message
                      </a>
                    </li>
                  </ul> */}
          {/* <!-- END : Email submenu list --> */}
          {/* </li> */}
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          {/* <li className="nav-item has-sub">
                  <a href="#" className="mininav-toggle nav-link collapsed">
                    <i className="demo-pli-file-html fs-5 me-2"></i>
                    <span className="nav-label ms-1">Other Pages</span>
                  </a> */}

          {/* <!-- Other Pages submenu list --> */}
          {/* <ul className="mininav-content nav collapse">
                    <li className="nav-item">
                      <a
                        href="./other-pages-blank-page.html"
                        className="nav-link"
                      >
                        Blank Page
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./other-pages-invoice.html" className="nav-link">
                        Invoice
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./other-pages-search-results.html"
                        className="nav-link"
                      >
                        Search Results
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./other-pages-faq.html" className="nav-link">
                        FAQ
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./other-pages-pricing-tables.html"
                        className="nav-link"
                      >
                        Pricing Tables
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./other-pages-error-404.html" className="nav-link">
                        Error 404
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./other-pages-error-500.html" className="nav-link">
                        Error 500
                      </a>
                    </li>
                  </ul> */}
          {/* <!-- END : Other Pages submenu list --> */}
          {/* </li> */}
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          {/* <li className="nav-item has-sub">
                  <a href="#" className="mininav-toggle nav-link collapsed">
                    <i className="demo-pli-window-2 fs-5 me-2"></i>
                    <span className="nav-label ms-1">Front Pages</span>
                  </a> */}

          {/* <!-- Front Pages submenu list --> */}
          {/* <ul className="mininav-content nav collapse">
                    <li className="nav-item">
                      <a href="./front-pages-error-404.html" className="nav-link">
                        Error 404
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./front-pages-error-500.html" className="nav-link">
                        Error 500
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./front-pages-maintenance.html"
                        className="nav-link"
                      >
                        Maintenance
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./front-pages-login.html" className="nav-link">
                        Login
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="./front-pages-register.html" className="nav-link">
                        Register
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./front-pages-password-reminder.html"
                        className="nav-link"
                      >
                        Password Reminder
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./front-pages-lock-screen.html"
                        className="nav-link"
                      >
                        Lock Screen
                      </a>
                    </li>
                  </ul> */}
          {/* <!-- END : Front Pages submenu list --> */}
          {/* </li> */}
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          {/* <li className="nav-item has-sub">
                  <a href="#" className="mininav-toggle nav-link collapsed">
                    <i className="demo-pli-tactic fs-5 me-2"></i>
                    <span className="nav-label ms-1">Menu Levels</span>
                  </a>
                  <ul className="mininav-content nav collapse">
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Menu Link
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Menu Link
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Menu Link
                      </a>
                    </li>
                    <li className="nav-item has-sub">
                      <a href="#" className="mininav-toggle nav-link collapsed">
                        Submenu
                      </a>
                      <ul className="mininav-content nav collapse">
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item has-sub">
                      <a href="#" className="mininav-toggle nav-link collapsed">
                        Submenu
                      </a>
                      <ul className="mininav-content nav collapse">
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            Menu Link
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li> */}
          {/* <!-- END : Link with submenu --> */}
        </ul>
      </div>
    </>
  );
};

export default ClientNav;
